






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Caretaker } from '@/models/index'

@Component({
  name: 'SorewardsCaretakerSelect'
})
export default class extends Vue {
  @Prop({ default: '' }) private value!: string
  @Prop({ default: '' }) private name!: string
  @Prop({ default: '' }) private placeholder!: string
  @Prop({ default: false }) private fullWidth!: boolean

  private loading = false
  private options: Caretaker[] = []

  get displayOptions() {
    if (this.value && this.name && !this.options.find(caretaker => caretaker.id === this.value)) {
      return [new Caretaker({ id: this.value, name: this.name }), ...this.options]
    }
    return this.options
  }

  created() {
    this.search('')
  }

  private async search(query: string) {
    this.loading = true
    try {
      let scope = Caretaker
        .page(1)
        .per(20)
        .order({ name: 'asc' })

      if (query) {
        scope = scope.where({ name: { prefix: query } })
      }

      const { data } = await scope.all()
      this.options = data
    } finally {
      this.loading = false
    }
  }

  private onVisibleChange(open: boolean) {
    if (open && !this.options.length) {
      this.search('')
    }
  }

  private onChange(id: string) {
    const caretaker = this.displayOptions.find(item => item.id === id)
    this.$emit('update:name', caretaker ? caretaker.name : '')
    this.$emit('input', id || '')
  }
}
